<template>
	<div class="diff-wrap">
		<template v-if="view_type === 'list'">
			<template v-if="hasView">
				<div class="diff--head">
					<label class="radio-inline" v-for="v in views" :id="`item-${itemKey}-view-${v.id}`">
						<input
							class="form-check-input"
							type="radio"
							:name="`item-${itemKey}-view`"
							:id="`item-${itemKey}-view-${v.id}`"
							:value="v.id"
							v-model="view"
						/>
						{{ v['name'] }}
					</label>
				</div>
			</template>
			<div class="diff--content">
				<blockquote>
					<template v-if="hasView">
						<template v-for="diff in diffValue">
							<template
								v-if="
									view === DIFF_VIEW || (view === OLD_VIEW && !diff['added']) || (view === NEW_VIEW && !diff['removed'])
								"
							>
								<span :class="{ removed: diff['removed'], added: diff['added'] }">{{
									diff['value'] && diff['value'].trim() ? diff['value'] : '&nbsp;'
								}}</span>
							</template>
						</template>

						<template v-if="isLongView">
							<div>
								<button class="button button-primary button-lg" style="margin-top: 20px" @click="_handleClickHideDiff">
									Скрыть
								</button>
							</div>
						</template>
					</template>

					<template v-else-if="hasView === false">
						<span>{{ newRawValue.substring(0, 247) + '...' }}</span>

						<div>
							<button class="button button-primary button-lg" style="margin-top: 20px" @click="_handleClickShowDiff">
								Показать полностью
							</button>
						</div>
					</template>
				</blockquote>
			</div>
		</template>
		<template v-else>{{ newValue }}</template>
	</div>
</template>

<script>
import moment from 'moment';
const Diff = require('diff');

const DIFF_VIEW = 0;
const OLD_VIEW = 1;
const NEW_VIEW = 2;

const MIN_LENGTH_FUNC = 50; // Value меньше чем MIN_LENGTH_FUNC сравниваются линиями
const MAX_LENGTH_FUNC = 100; // Value не больше MAX_LENGTH_FUNC и валидная почта/дата/урл

const MAX_LENGTH_TEXT = 500; // Такие огромные текста не сравниваем в этом компоненте.

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSSS';

const validateEmail = (email) => {
	const pattern = /.+@.+/; // CWP-18020
	return pattern.test(String(email).toLowerCase());
};

const validateURL = (url) => {
	const pattern = new RegExp(
		'^((https|http|ftp|rtsp|mms)?://)' + // protocol
			"?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" +
			'(([0-9]{1,3}\.){3}[0-9]{1,3}' + /// ip (v4) address
			'|' + // ip (v4) address
			"([0-9a-z_!~*'()-]+\.)*" + // www.
			'([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.' +
			'[a-z]{2,6})' + // first level domain- .com or .museum
			'(:[0-9]{1,4})?' + //port
			'((/?)|' + // a slash isn't required if there is no file name
			"(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$",
		'i',
	);

	return pattern.test(String(url).toLowerCase());
};

export default {
	name: 'spc_diff_checkers',
	props: {
		view_type: {
			type: String,
		},
		value: {
			default: '',
		},
		field_meta: {
			type: Object,
		},
		record_data: {
			type: Object,
		},
		inWindowVisible: {
			type: Boolean,
		},
	},
	data() {
		const view =
			(this.record_data.new_value && this.record_data.new_value.length > MAX_LENGTH_TEXT) ||
			(this.record_data.old_value && this.record_data.old_value.length > MAX_LENGTH_TEXT)
				? null
				: DIFF_VIEW;

		return {
			view,
			moment,
			OLD_VIEW,
			NEW_VIEW,
			DIFF_VIEW,
			diffValue: [],
			isLongView: view === null,
		};
	},
	computed: {
		newRawValue() {
			return this.record_data['new_value'] || ' ';
		},
		oldRawValue() {
			return this.record_data['old_value'] || ' ';
		},
		newValue() {
			let value = this.newRawValue;

			if (this.isDate && moment(value, DATE_FORMAT, true).isValid()) {
				value = moment(value).format('DD.MM.YYYY HH:mm:ss');
			}

			return value;
		},
		oldValue() {
			let value = this.oldRawValue;

			if (this.isDate && moment(value, DATE_FORMAT, true).isValid()) {
				value = moment(value).format('DD.MM.YYYY HH:mm:ss');
			}

			return value;
		},
		isDate() {
			// console.log(moment("2020-04-30T18:33:00+04:00", "YYYY-MM-DDTHH:mm:ssZ", true).isValid())
			// console.log(moment("2020-04-30 23:33:33.0", "YYYY-MM-DD HH:mm:ss.SSSS", true).isValid())

			return (
				(this.newRawValue &&
					this.newRawValue.length <= MAX_LENGTH_FUNC &&
					moment(this.newRawValue, DATE_FORMAT, true).isValid()) ||
				(this.oldRawValue &&
					this.oldRawValue.length <= MAX_LENGTH_FUNC &&
					moment(this.oldRawValue, DATE_FORMAT, true).isValid())
			);
		},
		isEmail() {
			return Boolean(
				(this.newRawValue && this.newRawValue.length <= MAX_LENGTH_FUNC && validateEmail(this.newRawValue)) ||
					(this.oldRawValue && this.oldRawValue.length <= MAX_LENGTH_FUNC && validateEmail(this.oldRawValue)),
			);
		},
		isUrl() {
			return Boolean(
				(this.newRawValue && this.newRawValue.length <= MAX_LENGTH_FUNC && validateURL(this.newRawValue)) ||
					(this.oldRawValue && this.oldRawValue.length <= MAX_LENGTH_FUNC && validateURL(this.oldRawValue)),
			);
		},
		hasView() {
			return this.view !== null;
		},
		views() {
			return [
				{ id: DIFF_VIEW, name: 'Сравнение' },
				{ id: NEW_VIEW, name: 'Новое значение' },
				{ id: OLD_VIEW, name: 'Старое значение' },
			];
		},
		itemKey() {
			const { ITEM_KEY } = this.record_data;
			return ITEM_KEY;
		},
	},
	watch: {
		inWindowVisible(value) {
			if (this.hasView && value === true && this.diffValue.length === 0) {
				this.diffValue = this._getDiffValue();
			}
		},
	},
	methods: {
		_handleClickShowDiff() {
			this.view = DIFF_VIEW;
			this.diffValue = this._getDiffValue();
		},
		_handleClickHideDiff() {
			this.view = null;
			this.diffValue = [];
		},
		_getDiffValue() {
			if (
				this.isDate ||
				this.isEmail ||
				this.isUrl ||
				this.oldValue.length <= MIN_LENGTH_FUNC ||
				this.newValue.length <= MIN_LENGTH_FUNC
			) {
				return Diff.diffLines(this.oldValue, this.newValue);
			} else return Diff.diffWords(this.oldValue, this.newValue);
		},
	},
};
</script>

<style lang="css" scoped>
.diff-wrap {
	position: relative;
}

.diff-wrap .diff--head {
	position: relative;
}

.diff-wrap .diff--content {
	margin-top: 10px;
}

.diff-wrap .diff--content blockquote {
	margin-bottom: 10px;
}

.diff-wrap .diff--content span {
	text-decoration: none;
	display: inline;
	white-space: pre-wrap;
}

.diff-wrap .diff--content .removed {
	color: #b30000;
	background: #fadad7;
}

.diff-wrap .diff--content .added {
	color: #406619;
	background: #eaf2c2;
}
</style>
